<template>
    <Dialog>
        <template v-slot:title>
            {{ $t('message.assign_talkgroup_to_ai', { AI_APP: processorDefinition.displayName }) }}
        </template>

        <template v-slot:body>
            <table width=100% height=100% cellpadding=0 cellspacing=0>
                <tr>
                    <td colspan=2>
                        <div style="padding: 10px;">
                            <el-form @submit.native.prevent="findGroup()">
                                <el-radio-group style="padding-left:10px" v-model="listType" fill="#5171cb">
                                    <el-radio-button :label="0"><span v-t="'message.action_select_by_list'"/></el-radio-button>
                                    <el-radio-button :label="1"><span v-t="'message.action_select_by_search'"/></el-radio-button>
                                </el-radio-group>
                                <el-input v-if="listType === 1" :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" clearable class="object-search-select">
                                    <el-select v-model="condition" slot="prepend" :placeholder="$t('message.place_holder_search_condition')" class="search-item">
                                        <el-option :label="$t('message.item_groupId')" value="groupId"></el-option>
                                        <el-option :label="$t('message.item_groupDisplayName')" value="groupName"></el-option>
                                    </el-select>
                                    <el-button slot="append" style="width: 100px;vertical-align:middle" native-type="submit" v-t="'message.action_search_items'"></el-button>
                                </el-input>
                            </el-form>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="dialog-td">
                        <div class="inner-panel-header">
                            <div class="inner-panel-title">
                                <div class="inner-panel-title-left" v-t="'message.title_select_group'">
                                </div>
                                <div v-if="listType === 1" class="inner-panel-title-right">
                                    <button class="transparent" @click="selectTagAll()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>
                                </div>
                            </div>
                        </div>
                        <div v-if="listType === 0" class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                            <DialogTree
                                class="dialog-tree"
                                v-bind:initialData="[rootNode]"
                                @on-selectnode="handleOnSelectNode"
                                selectionType=2
                                ref="dialogTree"
                            />
                        </div>
                        <div v-else class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                            <div class="foundObject-record" v-for="object in foundGroupList" @click="addTagWithConditionCheck(object)">
                                <div class="foundObject">
                                    <span style="padding-left:10px;vertical-align:middle">{{ object.displayName }}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="dialog-td">
                        <div class="inner-panel-header">
                            <div class="inner-panel-title">
                                <div class="inner-panel-title-left" v-t="'message.title_editing_group'">
                                </div>
                                <div class="inner-panel-title-right">
                                    <button class="transparent" @click="removeAllTag()" type="button"><span class="normal-command-text" v-t="'message.action_delete_all'"></span></button>
                                </div>
                            </div>
                        </div>
                        <div id="selected-user" class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                            <div class="selected-item-field">
                                <div class="default-message" v-if="Object.keys(editTagList).length === 0" v-html="$t('message.hint_add_group_to_user')"></div>
                                <span v-for="tag in editTagList" v-bind:key="tag.id">
                                    <div class="userTag">
                                        <span class="userTag-name">{{ tag.displayName }}</span>
                                        <span class="closeTag" @click="removeTag(tag)">×</span>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </template>

        <template v-slot:button>
            <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
            <el-button class="dialog-ok-button" :disabled="disableSave" @click="saveUpdatedInfo()" v-t="'message.button_save'"></el-button>
        </template>
    </Dialog>
</template>

<script>
import Vue from 'vue'
import server from "@/components/ServerApi";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';
import Dialog from "@/components/pc/common/Dialog";
import DialogTree from "@/components/DialogTree.vue"
import processorTemplateUtil from '@/components/pc/setting/ai-app/AiAppSettingUtil.js';
import AiAppSettingUtility from "@/components/pc/setting/ai-app/AiAppSettingUtility";

const STATUS_SUCCESS = 0;
const STATUS_ALREADY_EXIST = -1;
const STATUS_UNMATCH_SPEECH_TO_TEXT = -2;
const STATUS_UNMATCH_TRANSLATION = -3;
const STATUS_UNMATCH_MAPTALK = -4;
const STATUS_UNMATCH_VIDEO = -5;
const STATUS_UNMATCH_STORAGE_ALREADY_ASSIGNED = -6;

export default {
    mixins:[AiAppSettingUtility],

    components: { Dialog, DialogTree},

    props: {
        tenantId: {
            type: Number,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        processorDefinition: {
            type: Object,
            required: true
        },
        assignedGroup: {
            type: Array,
            default: []
        }
    },

    data() {
        return {
            rootNode: {
                tenantId: this.tenantId,
                id: 1,
                label: "ROOT-NODE",
                type: 0,
                isLeaf: false
            },
            scrollOnAction: false,
            editTagList: {},
            orgTagList: {},
            addTagList: {},
            removeTagList: {},
            foundGroupList: [],
            listType: 0,
            condition: "groupId",
            searchString: null,
            disableSave: true,
            speechToText: false,
            storageType: false,
        };
    },

    created: function() {
        this.speechToText = processorTemplateUtil.needStt(this.processorDefinition);
        this.disableSave = true;
        this.storageType = (this.processorDefinition.serviceId === constants.VAULT_SERVICE_STORAGE);
        for (let talkgroup of this.assignedGroup) {
            this.$set(this.editTagList, talkgroup.id, talkgroup)
            this.$set(this.orgTagList, talkgroup.id, talkgroup)
        }
    },

    updated: function() {
        if (this.scrollOnAction) {
            let obj = document.getElementById("selected-user");
            obj.scrollTop = obj.scrollHeight;
            this.scrollOnAction = false;
        }
    },

    methods: {
        findGroup() {
            let param = { tenantId: this.tenantId }
            if (this.condition === "groupId") {
                param.name = this.searchString;
            } else if (this.condition === "groupName") {
                param.displayName = this.searchString;
            }

            let self = this;
            server.post("/findgroup", param)
            .then((res) => {
                if (res.data.status === constants.STATUS_SUCCESS) {
                    if (res.data.groupInfo.length === 0) {
                        self.foundGroupList = [];
                        commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_group_not_found").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_group")));
                        return;
                    }
                } else {
                    self.foundGroupList = [];
                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","findGroup").replace("{code}",res.data.status));
                    return;
                }
                self.foundGroupList = [];
                for (let objectInfo of res.data.groupInfo) {
                    let object = {
                        id: objectInfo.id,
                        name: objectInfo.name,
                        type: constants.OBJECT_TALKGROUP,
                        displayName: objectInfo.displayName,
                        optionFlag: objectInfo.optionFlag,
                        processorDefinitionIds: objectInfo.processorDefinitionIds
                    }
                    self.foundGroupList.push(object);
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "findGroup", error);
                self.foundGroupList = [];
            });
        },
        selectTagAll() {
            let addGroupCount = 0;
            for (let groupNode of this.foundGroupList) {
                if (this.checkConditionToAdd(groupNode) === STATUS_SUCCESS) {
                    this.addTag(groupNode)
                    addGroupCount ++;
                }
            }
            if (addGroupCount !== this.foundGroupList.length) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_all_object").replace("{object}",commonUtil.getMessageText(this.$i18n,"item_group")));
            }
        },
        addTagWithConditionCheck(tagInfo) {
            switch(this.checkConditionToAdd(tagInfo)) {
                case STATUS_SUCCESS:
                    this.addTag(tagInfo);
                    break;
                case STATUS_ALREADY_EXIST:
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_group_already_added"));
                    break;
                case STATUS_UNMATCH_SPEECH_TO_TEXT:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_group_no_speechText"));
                    break;
                case STATUS_UNMATCH_STORAGE_ALREADY_ASSIGNED:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_group_storage_already_assigned"));
                    break;
            }
        },
        addTag(tagInfo) {
            this.scrollOnAction = true;
            Vue.set(this.editTagList, tagInfo.id , tagInfo);
            Vue.delete(this.removeTagList, tagInfo.id);
            if (!(tagInfo.id in this.orgTagList)) {
                Vue.set(this.addTagList, tagInfo.id, tagInfo);
            }
            this.disableSave = false;
            return true;
        },
        checkConditionToAdd(tagInfo) {
            if (tagInfo.id in this.editTagList) {
                return STATUS_ALREADY_EXIST;
            }
            if (this.speechToText) {
                if (tagInfo.talkgroupOptions && !(tagInfo.talkgroupOptions.speechToTextEngine)) {
                    return STATUS_UNMATCH_SPEECH_TO_TEXT;
                }
                if (tagInfo.optionFlag && (tagInfo.optionFlag & (1 << constants.TALKGROUP_OPTION_SPEECH_TEXT)) == 0) {
                    return STATUS_UNMATCH_SPEECH_TO_TEXT;
                }
            }
            if (this.storageType) {
                for (let processorDefinitionId of tagInfo.processorDefinitionIds) {
                    let processorDefinition = processorTemplateUtil.getProcessorDefinitionFromListById(this.$root.store.processorDefinitionList, processorDefinitionId);
                    if (processorDefinition == null) {
                        continue;
                    }
                    if (processorDefinition.serviceId === constants.VAULT_SERVICE_STORAGE) {
                        return STATUS_UNMATCH_STORAGE_ALREADY_ASSIGNED;
                    }
                }
            }
            return STATUS_SUCCESS;
        },
        handleOnSelectNode(data,node) {
            // add talkGroup to user

            if (data.type === constants.OBJECT_TALKGROUP) {
                if ((data.id in this.editTagList)) {
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_group_already_added"));
                    return;
                }
            } else {
                return;
            }

            let self = this;
            server.post('/getinfo', {tenantId: this.tenantId, id: data.id})
                .then((res) => {
                    if (res.data.status >= 0) {
                        let tagInfo = {
                            id: data.id,
                            name: res.data.name,
                            type: constants.OBJECT_TALKGROUP,
                            displayName: res.data.displayName,
                            talkgroupOptions: res.data.talkgroupOptions,
                            processorDefinitionIds: res.data.processorDefinitionIds,
                        };
                        this.addTagWithConditionCheck(tagInfo);
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleOnSelectNode").replace("{code}",res.data.status));
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "handleOnSelectNode", error);
                });
        },

        removeTag: function(tag) {
            if ((tag.id in this.orgTagList)) {
                Vue.set(this.removeTagList, tag.id, tag);
            }
            Vue.delete(this.addTagList, tag.id);
            Vue.delete(this.editTagList, tag.id)
            this.disableSave = false;
        },

        removeAllTag: function() {
            for (let key in this.editTagList) {
                if ((key in this.orgTagList)) {
                    Vue.set(this.removeTagList, key, this.editTagList[key]);
                }
            }
            this.editTagList = {};
            this.addTagList = {};
            this.disableSave = false;
        },

        saveUpdatedInfo() {
            this.$emit('save' , { editTagList: this.editTagList, removeTagList: this.removeTagList , addTagList: this.addTagList } );
        }
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}
.dialog-tree >>> .el-tree-node__content {
    min-height: 40px !important;
    height: auto !important;
    white-space: normal !important;
    word-break: break-all !important;
    text-align: justify;
}
.dialog-tree >>>.el-tree-node__expand-icon {
    padding: 0px 28px !important;
}

</style>

